import { makeStyles, useTheme } from "@material-ui/core";
import React from "react";
import { connect } from "react-redux";
import { Theme } from "../.themes";
import { ApplicationState } from "../store/nissan_no";

const useStyles = makeStyles((theme: Theme) => ({
  headerWrapper: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    borderBottom: `1px solid #DEDAD4`,
    boxShadow: `rgba(0, 0, 0, 0.1) 0px 2px 4px -1px, rgba(0, 0, 0, 0.07) 0px 4px 5px 0px, rgba(0, 0, 0, 0.06) 0px 1px 10px 0px`,
    backgroundColor: theme.headerBackgroundColor || "transparent",
  },
  header: {
    display: "flex",
    flexWrap: "nowrap",
    maxWidth: theme.pageMaxWidth,
    width: "100%",
    justifyContent: "space-between",
    alignItems: "center",
    paddingLeft: 24,
    paddingRight: 24,
    height: 72,
    overflow: "hidden",
    gap: 16,
    [theme.breakpoints.down("sm")]: {
      height: 56,
      gap: 8,
    },
    [theme.breakpoints.down("xs")]: {
      height: 48,
      gap: 4,
    },
  },
  logoImg: {
    maxWidth: 180,
    maxHeight: 40,
    objectFit: "contain",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "48%",
      maxHeight: 40,
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: 124,
      maxHeight: 40,
    },
  },
}));

interface HeaderProps {
  mainLogoUrl?: string;
  mainLogoAlt?: string;
  secondaryLogoUrl?: string;
  secondaryLogoAlt?: string;
}

const Header = ({ mainLogoUrl, mainLogoAlt, secondaryLogoUrl, secondaryLogoAlt }: HeaderProps) => {
  const theme: Theme = useTheme();
  const classes = useStyles(theme);

  return (
    <header className={classes.headerWrapper}>
      <div className={classes.header}>
        {mainLogoUrl ? (
          <img
            src={mainLogoUrl}
            alt={mainLogoAlt || "Main Logo"}
            className={classes.logoImg}
            style={{ marginRight: secondaryLogoUrl ? 8 : 0 }}
          />
        ) : null}
        {secondaryLogoUrl ? (
          <img
            src={secondaryLogoUrl}
            alt={secondaryLogoAlt || "Secondary Logo"}
            className={classes.logoImg}
            style={{ marginLeft: mainLogoUrl ? 8 : 0 }}
          />
        ) : null}
      </div>
    </header>
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  mainLogoUrl: state.inputs.decoupledRendering?.mainLogo,
  mainLogoAlt: state.inputs.decoupledRendering?.mainLogoAlt,
  secondaryLogoUrl: state.inputs.decoupledRendering?.secondaryLogo,
  secondaryLogoAlt: state.inputs.decoupledRendering?.secondaryLogoAlt,
});

export default connect(mapStateToProps)(Header);
